import { render, staticRenderFns } from "./ClimbingElectronics.vue?vue&type=template&id=7de46562&"
import script from "./ClimbingElectronics.vue?vue&type=script&lang=js&"
export * from "./ClimbingElectronics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports